module.exports = __webpack_public_path__ + "assets/img/btn-detail-1319628a.png";